import { TypeHelper } from "./TypeHelper";

export class ValidationHelper {

    public static testRegex(val: string, regex: string): boolean {
        const regexp = new RegExp(regex);
        const result = regexp.test(val);
        return result;
    }

    public static stringContainsIntegersOnly(val: string): boolean {
        const regex = /^\d+$/;
        const regexp = new RegExp(regex);
        const result = regexp.test(val);
        return result;
    }

    public static removeCarriageReturns(val: string) {
        return val ? val.replace(/(\r\n\t|\n|\r\t)/gm, "") : val;
    }

    public static isNullOrUndefinedOrEmpty(val: string | null | undefined) {
        return val === null || val === undefined || ValidationHelper.removeCarriageReturns(val).length === 0;
    }

    public static isNullOrUndefined(val: any | null | undefined) {
        return TypeHelper.isNullOrUndefined(val);
    }

    public static hasValueGreaterThanZero(val: number | null | undefined) {
        return val !== null && val !== undefined && val > 0;
    }

    public static numericStringValueGreaterThanZero(val: string | null | undefined) {
        if ( val !== null && val !== undefined) {
            const intValue = parseFloat(val);
            if (!isNaN(intValue)) {
                return intValue > 0
            }
        }
        return false;
    }

    public static stringIsEmpty(val: string | null | undefined) {
        return val === null || val === undefined || val.length === 0;
    }

    public static booleanIsTrue(val?: boolean) {
        return val !== null && val !== undefined && val;
    }

    public static replaceNullOrUndefinedInString(val: string, setDefault: string = "Add New") {
        if (this.isNullOrUndefinedOrEmpty(val)) return setDefault;
        const valtoCheck = val.toLowerCase().trim();
        const invalidCheck = ["unknown", "undefined", "null"];

        const isInValid = invalidCheck.filter(x => valtoCheck.indexOf(x) >= 0);

        return isInValid.length > 0 ? setDefault : val;
    }

}
